import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./PurchaseHistory.css";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://techiohisab.com/api";
const API = `${API_BASE}/purchase-history/summary`;

export default function PurchaseHistory() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(API);
      setSummary(res.data || []);
    } catch (err) {
      console.error("Purchase history error:", err);
      setSummary([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <div className="page-container">
      <div className="history-header">
        <button
          id="purchase-history-sales-style-back-btn"
          type="button"
          className="back-btn purchase-history-sales-back-btn"
          onClick={() => navigate("/purchases")}
        >
          Back
        </button>
        <h2>Purchase History</h2>
        <div style={{ fontSize: "12px", color: "#64748b", marginLeft: "10px" }}>(Purchase Summary)</div>
      </div>

      <table className="inventory-table">
        <thead>
          <tr>
            <th>Supplier</th>
            <th>Total Orders</th>
            <th>Total Qty</th>
            <th>Item Total</th>
            <th>Expense Total</th>
            <th>Grand Total</th>
            <th>Last Update</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {loading && (
            <tr>
              <td colSpan="8" className="empty-row">
                Loading purchase history...
              </td>
            </tr>
          )}

          {!loading &&
            summary.map((s) => (
              <tr key={s.supplier_id}>
                <td>{s.supplier_name || "-"}</td>
                <td style={{ fontWeight: 800 }}>{Number(s.total_orders || 0)}</td>
                <td>{Number(s.total_qty || 0)}</td>
                <td>₹{Number(s.item_total || 0).toFixed(2)}</td>
                <td>₹{Number(s.expense_total || 0).toFixed(2)}</td>
                <td className="total-cell">₹{Number(s.grand_total || 0).toFixed(2)}</td>
                <td>{s.last_update_at ? new Date(s.last_update_at).toLocaleDateString("en-IN") : "-"}</td>
                <td>
                  <button
                    className="view-btn"
                    onClick={() =>
                      navigate(`/purchase/history/${s.supplier_id}`, {
                        state: { supplier_name: s.supplier_name },
                      })
                    }
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}

          {!loading && summary.length === 0 && (
            <tr>
              <td colSpan="8" className="empty-row">
                No purchase history found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
